
import { Component, VModel, Prop, Watch, Vue } from "vue-property-decorator";

import PazAdressPicker from "@pazion/pazion-catalog/src/components/picker/PazAdressPicker.vue";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import PazAjaxTable from "@pazion/pazion-core/src/components/layout/PazAjaxTable.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";

import { IAddressType } from "../../models/adress";
import { fieldsByClass } from "@pazion/pazion-core/src/services/settings-fields";
import { getUsers } from "@pazion/pazion-core/src/services/auth-service";
import { IUserLisApiModel } from "@pazion/pazion-core/src/models/user-models";

import { baseRegexp } from "../../helpers/constants";

import {
  getAdressForAccount,
  deleteAdress,
  getAddressesTypes,
  getAccountUsers,
  setAccountUser,
  deleteAccountUser,
  getLedgerCodeOptions
} from "../../services/catalog-service";

@Component({
  components: {
    PazAdressPicker,
    PazTooltipButton,
    PazLoader,
    PazConfirmation,
    PazToast,
    PazAjaxTable,
    PazTextSearch,
  },
  methods: {
    fieldsByClass,
    setAccountUser,
  },
})
export default class PazAccountDialog extends Vue {
  $refs!: {
    toast: PazToast;
  };

  @VModel({
    default: false,
  })
  public showAccountDialog!: boolean;
  @Prop() account!: any;

  @Prop({ default: () => [] })
  public tenantOptionsList!: { title: string; value: number }[];

  @Prop({ default: () => [] })
  public ledgerCodeOptionsList!: { title: string; value: number }[];

  @Prop({ default: false })
  public isShowTenant!: boolean;

  public loading: boolean = false;
  public accountFormModel: boolean = false;
  public accountFormAddressesModel: boolean = false;
  public formValidations = {
    contact: [(value) => !!value || "Required."],
    email: [(value) => baseRegexp.emailRegex.test(value) || "Wrong format"],
    phone: [(value) => baseRegexp.phoneRegex.test(value) || "Wrong format"],
  };
  public specialValidation = {
    email: baseRegexp.emailRegex,
    phone: baseRegexp.phoneRegex,
  };
  public accountObject = {
    contact: null,
    email: null,
    notes: null,
    vat: null,
    kvk: null,
    reference: null,
    business: null,
    phone: null,
    defaultBillingAddress: null,
    defaultShippingAddress: null,
    tenant: null,
  };
  public addressesItem = [];
  public showAdressPicker = false;
  public selectedAddress = {};
  public addressTypes: IAddressType[] = [];
  public accountUsersOnly: boolean = true;
  public search: string = "";

  getNameOfType(addressTypeId: number) {
    return this.addressTypes.find(
      (type: IAddressType) => type.id == addressTypeId
    )?.nameTech;
  }

  getAddressString(currentAddress) {
    return `${
        currentAddress.name
    }, ${currentAddress.street} ${currentAddress.houseNumber}, ${
        currentAddress.zipcode
    }, ${currentAddress.city}`;
  }


  canBeDefaultAddress(address) : boolean{
    return ['shipping','billing'].includes(this.getNameOfType(address.addressType));
  }

  async setDefaultAddress(address){
    switch (this.getNameOfType(address.addressType)){
      case 'shipping':
        this.accountObject.defaultShippingAddress = address.id;
        break;
      case 'billing':
        this.accountObject.defaultBillingAddress = address.id;
        break;
    }
    await this.accountUpdateHandler(this.accountObject, false);


  }

  onAccountEdit(address) {
    this.showAdressPicker = true;
    this.selectedAddress = address;
  }

  get filteredUsersList() {
    if (this.accountUsersOnly) {
      return this.usersList.filter((user) => {
        return this.accountUsersData.some((i) => i.user === user.id);
      });
    }
    return this.usersList;
  }

  async accountUpdateHandler(account: any, clearSelection?:bool) {
    await this.$refs.accountForm.validate();
    if (!this.accountFormModel) return;
    this.$emit("onAccountChange", {
      data: account,
      isEdit: this.isEditAccount,
      clearSelection
    });
  }

  isDefaultAddress(address: any) : boolean {
    if (!address || !address.id) {
      return false;
    }
    return address.id == this.accountObject.defaultShippingAddress || address.id == this.accountObject.defaultBillingAddress;

  }

  get isEditAccount() {
    return !!this.account;
  }

  async fetchAddressesData() {
    if (this.account) {
      this.addressesItem = await getAdressForAccount(this.account.id);
      this.addressTypes = await getAddressesTypes();
    }
    this.showAdressPicker = false;
  }

  async onDeleteAdress(address: any) {
    const confirm = await this.$refs.confirmDeleteAddress.openConfirmDialog(
      "Delete",
      `Do you want to delete address: ${address.name}?`
    );
    if (!confirm) return;
    const response = await deleteAdress(address.id);

    if (!response || !response.hasOwnProperty("id")) {
      this.$refs.toast.show({
        message: "An error occurred, Account hasn't been deleted",
        icon: "mdi-close-circle",
        color: "red",
      });
      return;
    }
    this.fetchAddressesData();
  }

  fieldByType(field: string, type: string) {
    return this.fieldsByClass(this, field, "CustomerPicker")[type];
  }

  nv(field: string, v: any) {
    return (
      (this.fieldByType(field, "required") ? !!v : true) ||
      `${this.fieldByType(field, "label")} is required`
    );
  }
  public usersList = [] as IUserLisApiModel[];
  public accountUsersData = [];

  isAccountUser(item) {
    return this.accountUsersData.some((user) => user.user === item.id);
  }

  get headers() {
    return [
      { text: "Account user", align: "start", sortable: true, value: "member" },
      {
        text: "Email",
        align: "start",
        sortable: true,
        value: "username",
      },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: "Actions",
        align: "end",
        sortable: true,
        value: "extra",
        width: 100,
      },
    ];
  }

  async removeAccountUser(item: any) {
    const confirm = await this.$refs.confirmDeleteAddress.openConfirmDialog(
      "Delete",
      `Do you want to delete account user: ${item.username}?`
    );
    if (!confirm) return;
    try {
      const id = this.accountUsersData.find(
        (user) => user.user === item.id
      )?.id;
      await deleteAccountUser(id);
      await this.fetchData();
      this.$refs.toast.show({
        message: `${item.username} has been successfully deleted`,
        color: "success",
      });
    } catch {
      this.$refs.toast.show({
        message: "An error occurred, Account user hasn't been deleted",
        icon: "mdi-close-circle",
        color: "red",
      });
    }
  }

  public isLoadingAddButton: boolean = false;

  async addAccountUser(id: number) {
    this.isLoadingAddButton = true;
    try {
      await setAccountUser({
        accountId: this.account.id,
        userId: id,
      });
      await this.fetchData();
      this.$refs.toast.show({
        message: "Account user has been successfully added",
        color: "success",
      });
    } catch {
      this.$refs.toast.show({
        message: "An error occurred, Status hasn't been changed",
        icon: "mdi-close-circle",
        color: "red",
      });
    } finally {
      this.isLoadingAddButton = false;
    }
  }

  async fetchData() {
    this.account && Object.assign(this.accountObject, this.account);
    [this.usersList] = await Promise.all([
      await getUsers(),
      this.fetchAddressesData(),
    ]);
    const res = await getAccountUsers({
      account: { eq: this.account.id },
    });
    this.accountUsersData = res._data;
    this.accountUsersData = this.accountUsersData.map((accountUser) => {
      const userData = this.usersList.find(
        (user) => user.id === accountUser.user
      );
      return { ...accountUser, userData };
    });
  }

  async loadLedgerOptions() {

    const ledgerCodes = await getLedgerCodeOptions();
    this.ledgerCodeOptionsList = ledgerCodes.map((ledgerCode) => {
      return { title: ledgerCode.name, value: ledgerCode.id };
    });
    this.ledgerCodeOptionsList.unshift({ title: '- empty -', value: null });
  }

  async mounted() {
    this.loading = true;
    try {
      await this.fetchData();
      await this.loadLedgerOptions();
    } finally {
      this.loading = false;
    }
  }

  @Watch("search")
  handleSwitchUsers(newValue: string) {
    this.accountUsersOnly = !newValue.length;
  }
}
